module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Chapter-Two.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-16"
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_vm._v("CHAPTER TWO")])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  }, [_c('p', {
    staticClass: "body-text-opening"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("“I’")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("M")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("PUTTING")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("BUTTERFLIES")]), _vm._v(" on this, but it needs stitches,” Lynn Duncan said, her tone as matter-of-fact as she could make it while tending to the brutalized skin of the twenty-four-year-old brunette sitting on the table in one of the two small examination rooms at The Lemonade Stand Tuesday evening.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I hate hospitals.” Regina Cooper wasn’t crying as she gave yet another reason she was refusing to allow herself to be stitched. Lynn almost wished Regina "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" sobbing, even though that would make her task more difficult. The younger woman’s voice was deadpan, her words slurred as she formed them through cut and swollen lips. Like the life had been beaten out of her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I can do it right here,” Lynn said. Technically she was off shift, but when you lived on the premises of one’s job, you tended to be on call 24/7. Not that Lynn minded.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At-risk women came to The Lemonade Stand in coastal Santa Raquel, California, to find shelter. Lynn had found her life’s purpose here, nursing them.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Tending to the third of three ugly cuts on the woman’s chin and neck—one the result of a knockout punch to her mouth and the other two gashes from the glass that broke when it had been thrown at her—she said, “These are going to scar, Ms. Cooper, if we don’t get them stitched properly.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I don’t care.” Regina hadn’t said much in the half hour since she’d arrived at The Lemonade Stand, partially, Lynn suspected, because it hurt too much to talk.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re a beautiful young woman,” she said. “You’ve got your whole life ahead of you. And we need to get these taken care of properly.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Sara Havens, one of the Stand’s counselors, was outside, waiting to take Regina under her wing. She’d know better what to say. But they didn’t have weeks, or even days, for counseling to change Regina’s mind about these cuts.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A member of the Stand’s small full-time security team was there, too, standing guard.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Lynn’s face was inches from the other woman’s as she gently worked the torn skin together as well as she could. Regina’s pretty blue eyes met hers. “You see where my beauty got me?” she asked in a near-whisper, her eyes growing moist but not enough for a tear to fall. “I can do without it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’ll remember him, and the beating you just took, every single time you look in the mirror if we don’t get these properly stitched,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m going to remember anyway.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You want to wear his anger? To keep him with you every minute of every day for the rest of your life?” Nursing school had taught her how to tend to bodies. The year she’d spent in grad school after Kara’s birth had provided her with her advanced nursing midwifery certification. The two years she’d been living full-time at The Lemonade Stand had been a completely different education. “You want to let him mark you that way?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Tears blurred the hurt-filled blue eyes. “I can’t afford stitches,” the woman said. “I don’t even know how I’m going to pay for the butterfly bandages. I can’t use my health insurance. It’s through his work and he’ll know where to find me....”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Stopping her work, Lynn studied the younger woman. “That’s why you won’t agree to stitches? Because of the cost?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Regina nodded. “I went to the ATM as soon as I left, but he’d already drained our account. I’ve got a hundred bucks on me, this week’s grocery allowance, and that’s it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Regina spoke slowly, sounding as if she had marbles in her mouth, but she made herself understood.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Going for stitching supplies, Lynn pulled on a fresh pair of sterilized procedure gloves. “Your care here is free, Regina,” she said. “I thought you knew that.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Medical care, too?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Everything. For the first four weeks you’re here, you have access to all services, and pay only what you can afford to pay. If that’s nothing, then nothing is what you owe.” She smiled at the young woman. “Now, are you going to let me take proper care of you and get this stitched?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Yes, ma’am.” Regina’s mouth wouldn’t allow a smile, but the relieved look in her eyes spoke volumes.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And twenty minutes later, when Lynn turned over her newest patient to Sara Havens, who would see Regina through the admissions process and get her set up with clean clothes, toiletries and a safe place to sleep, she was fairly certain she’d managed to minimize the damage Regina’s husband’s brutality had inflicted.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("At least on the surface.")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("“L")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("YNN")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("?” T")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("HIRTY")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("-")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("FIVE")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("-")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("YEAR")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("-")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("OLD")]), _vm._v(" Maddie Estes, one of only a few permanent residents at The Lemonade Stand, looked upset as she hurried toward Lynn just after Sara escorted Regina out of the three-room health clinic located in the main house.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“What’s up, Maddie?” Lynn smiled at the pretty woman who was three years older than her by birth, but fifteen years younger in mental acuity. Maddie’s developmental challenges, present since a premature birth, caused the sweet, gentle woman to worry over small things.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("But with regular weekly physical therapy sessions, Maddie’s motor skills, while slow, were finally within the normal range.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The woman’s hands were flailing as she moved.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“There’s a man here. He’s been waiting to see you for a long time. He looks like he might be getting mad. You know, walking back and forth and back and forth in the hallway and slapping his baseball cap against his hand.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Maddie emulated the motion with jerky movements, her gaze meeting Lynn’s only for a brief stop as it traveled around the space they occupied—the empty waiting room at the clinic. Lynn held regular, well-check office hours. They’d long since passed on that particular Tuesday in February.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“A man?” Lynn frowned, more concerned by Maddie’s agitation than any visitor she might have. “Did he say who he was?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("After suffering for fourteen years at the hands of a man who’d once adored her but had grown to hate the sight of her, Maddie was extrasensitive to any sign of male aggression. And Lynn was particularly protective of Maddie.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Grant...I can’t remember what. I’m sorry, Lynn. I know I should remember, but he’s just so upset, and your treatment light was on and I didn’t know what to do so I took him to the bench in the main hall and waited back here for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Grant Bishop!” Lynn said, remembering. She’d had an appointment with the man almost an hour ago. And had completely forgotten.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’d called that morning, said he couldn’t get there until four-thirty. And if he had a woman in jeopardy, she’d just made them wait even longer.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You know him, then? I’m sorry, Lynn, I probably made him mad, but—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("With one hand stilling Maddie’s twisting hands, Lynn looked the woman straight in the eye and said, “It’s okay, Maddie. You did the right thing.” Maddie’s fidgeting stilled instantly.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“And now, can you do a favor for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Of course!” Maddie smiled. She agitated easily, but she settled easily, too.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Kara’s in the playroom,” Lynn said, picturing her curly-haired three-year-old with a crayon in her hand and her tongue sticking out of her mouth. “I was supposed to pick her up at six and it’s almost that now. Can you collect her and take her home for me? There’s some leftover macaroni and cheese in the fridge. I’ll be there as soon as I can be.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Of course!” Maddie said again, hurrying away down the hall, but turning back before she got far. “Can I give her her bath, too?” Maddie asked.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Lynn liked to reserve bath time—and bedtime story reading—for herself. To keep some semblance of normal family and routine for the preschooler who was growing up so untraditionally in the arms of so many people who loved her.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“How about if we give her her bath together?” Lynn suggested, now conscious of the man waiting for her. Bath time was at eight, as delineated by the detailed schedule Lynn kept on her refrigerator. A schedule that Maddie followed religiously. “I’ll be home in plenty of time,” she assured the short but slender blonde woman.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Okay, Lynn.” Maddie’s expression was serious. “And we’ll save some macaroni for you, too. You’ll get hungry if you don’t have dinner.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Bless Maddie. She might struggle to understand the monetary value of coins and dollars, to connect the heating and lighting in her room with a bill that had to be paid, or to ascertain the nuances of human interaction, but she knew how to pay attention. To nurture.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And she was adamant about nurturing Lynn and Kara most of all.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("They were lucky to be so loved.")]), _vm._v(" "), _c('p', {
    staticClass: "tb"
  }, [_vm._v("* * *")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-tab"
  }, [_c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("F")]), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("OR")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("THE")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _c('span', {
    staticClass: "sc-epub",
    attrs: {
      "xml:lang": "en-US"
    }
  }, [_vm._v("UMPTEENTH")]), _c('span', {
    staticClass: "sc",
    attrs: {
      "xml:lang": "en-US"
    }
  }), _vm._v("time Grant looked at his watch—and pulled his cell phone out of the holster on his belt, just to verify that the time he’d read on his wrist piece was accurate. He’d hoped to get to Darin by suppertime. To make certain that his brother ate. And did it sitting in his chair, not lying in bed.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The doctor had said Darin could get up as soon as he was ready. And he didn’t need his left hand to feed himself. Or to chew and swallow, either.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Almost as soon as he’d returned his phone to its holster, he felt it vibrate. Darin, wondering where he was?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Pulling the cell phone out, he was already answering when he saw the caller ID. Luke Stellar, his right-hand man.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“This is Grant,” he answered as he always did.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Fountain’s in and running.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("A rock edifice he’d designed to the homeowner’s specification. “What was the problem?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("When he’d had to leave at four-thirty to make his appointment at The Lemonade Stand before getting back to Darin, they’d had a water flow issue.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“A twist in the main line as it came around the first bend.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“The PVC track should have prevented that from happening.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Craig missed a piece of the track when he installed it.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("How did one miss a piece of a piping apparatus that fit together to make a whole?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m not sure he’s going to work out.” And Grant didn’t have time to hire another new guy. Craig had been with them six months and Grant had had high hopes for the kid.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“He just found out his wife’s having a baby,” Luke told him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Luke had two little kids. And he was late getting home to dinner with them. Again.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The guy never complained. And Grant had ridden both of his full-time employees hard that day.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I should have known that,” he said aloud, keeping his voice down as he paced the empty hallway—a twenty-by-ten-foot tiled area that was clearly separate and apart from the mysterious inner sanctum of The Lemonade Stand’s main building. “I owe you, man,” he told Luke now.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Buy me a beer sometime,” Luke shot back at him.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’d have to make that a twelve-pack. At the very least. If Grant didn’t have Darin... If he’d been able to give the business all of the time and energy Luke brought to it, they could have grown Bishop Landscaping into a lucrative company instead of a highly sought-after, well-booked, small-time operation that supported three families instead of dozens.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Telling Luke that he’d be at the job site at five-thirty the next morning to sign off on the work that had been done and to lay out the next phase of the waterfall garden’s installation, Grant rang off. He paced, and then came to rest in front of the glass door leading out to a small, nondescript visitor parking lot that needed shrubbery around it, some perennials for color....")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Mr. Bishop?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Turning, he recognized the woman approaching him at once. Her long hair was pulled back tightly from her face, but the warm glow in her eyes was just as he’d remembered.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’d told himself he’d imagined the woman’s effect on him the last time Darin had been in the hospital—four years before.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She’d had a wedding ring on back then. She didn’t now.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Lynn,” he said, because back then that’s all that had been written on her name tag—and that’s what he’d called her. She held out her hand. He took it.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("And didn’t want to let go.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You don’t remember me,” he said, quickly shoving his hands into the pockets of his jeans as he faced her in the empty, fluorescent-lit hallway. He’d heard that The Lemonade Stand was beautiful, a haven, resortlike. The commercial beige tile and white walls didn’t give him that impression at all.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I do, actually,” she said. “Now that I see you. I recognized your name when you called, but I wasn’t sure why. You’re the one with the brother. Darin, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’m impressed.” Grant smiled, in spite of how late he was for his visit with Darin. How late she’d made him. “You were his nurse for one day of a three-day stay, and have to have had hundreds of patients in your years as a nurse. You’ve got a good memory.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Darin was memorable.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("She didn’t say why. He could guess. Darin’s brain was damaged, his body wasn’t. Grant’s older brother had had girls goo-goo eyed over him for as long as Grant could remember. Even after so many years since his accident, Darin’s facial expression didn’t show his lack of mental coherence. You didn’t get that until you’d talked to him for a few minutes and experienced some of his childlike thought processes. Which were interspersed with moments of complete lucidity.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“So what can I do for you?” Lynn asked, that not-quite smile he remembered curving her lips and hitting him where a guy only liked to be hit when he could do something about it. “You said you needed to speak with me in person.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’d thought maybe they’d be sitting in her office, not standing out in the hall.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He’d thought she’d remember him, too, and she had. But more important, she’d remembered his brother.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("With enough affection to pull strings?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The Lemonade Stand was the only option he had. This had to work.")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph-14"
  })])]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })]), _c('a', {
    attrs: {
      "id": "Anchor-1"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74ebe9b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterTwo.vue
// module id = 81
// module chunks = 0